import { Typography } from '@carto/meridian-ds/components'
import { Paper, Grid, Box } from '@mui/material'
import CheckIconOutline from 'assets/icons/icon-action-check-circle-outline.svg?react'

interface HubspotSuccessMessageProps {
  successMessage: React.ReactElement | string
  primaryAction?: React.ReactElement
}

function HubspotSuccessMessage({ successMessage, primaryAction }: HubspotSuccessMessageProps) {
  return (
    <Paper elevation={0}>
      <Box pt={6} pb={6}>
        <Grid container direction="column" alignItems="center">
          <Box mb={2}>
            <CheckIconOutline />
          </Box>
          <Typography variant="body2" color="textSecondary">
            {successMessage}
          </Typography>
          {primaryAction && <Box mt={2}>{primaryAction}</Box>}
        </Grid>
      </Box>
    </Paper>
  )
}

export default HubspotSuccessMessage
